import { Box } from "@mui/material";

const AuthContainer = ({ children }) => {
    return (
        <Box className="form_box px-4 my-2 py-5" variant="div">
            {children}
        </Box>
    )
}

export default AuthContainer;